import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import common from './modules/common'
import site from './modules/site'
import studentFormDraft from './modules/studentFormDraft'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    common,
    site,
    studentFormDraft
  }
})

